import { useFilterWorkspace } from "@/features/search-filter/hooks/UseFilterWorkspace";
import { ApolloError } from "@apollo/client";
import { SeparatorLine } from "@stenajs-webui/core";
import { FlatButton } from "@stenajs-webui/elements";
import {
  StandardTable,
  createStandardTableInitialState,
  useLocalStateTableContext,
} from "@stenajs-webui/grid";
import { useMemo } from "react";
import {
  StatisticsAdvancedDataListColumns,
  createByAdvancedResultTableConfig,
} from "../config/StatisticsByAdvancedTableConfig";
import { UseAdvancedStatisticsDataListQuery } from "@/gql/graphql";

interface Props {
  currentCurrency: string;
  error: ApolloError | undefined;
  advancedStatisticsData:
    | UseAdvancedStatisticsDataListQuery["statistics"]["advancedList"]["byFilter"]["items"]
    | undefined;
  loading: boolean;
}

export const StatisticsByAdvancedTable: React.FC<Props> = ({
  currentCurrency,
  error,
  advancedStatisticsData,
  loading,
}) => {
  const { openFilter } = useFilterWorkspace();

  const { tableContext } = useLocalStateTableContext(
    "advanced-statistics-table-context",
    createStandardTableInitialState<StatisticsAdvancedDataListColumns>(
      "customerName",
      false
    )
  );

  const resultConfig = useMemo(() => {
    return createByAdvancedResultTableConfig(currentCurrency);
  }, [currentCurrency]);

  return (
    <>
      <StandardTable
        loading={loading}
        error={error}
        items={advancedStatisticsData ?? []}
        config={resultConfig}
        noItemsContentRight={
          <FlatButton label={"Open filter"} onClick={() => openFilter()} />
        }
        tableContext={tableContext}
        noItemsHeader={"Search for advanced statistics data."}
        noItemsLabel={
          "Please use the filters to search for advanced statistics data."
        }
      />
      {advancedStatisticsData && !loading ? <SeparatorLine /> : null}
    </>
  );
};
